// extracted by mini-css-extract-plugin
module.exports = {"page":"browse-page_page__3BQXe"};